export default "__VITE_ASSET__BMYF5PP2__"